import { SiteContext } from "../../Contexts/SiteContext";
import { _oldSelectImageForDevice } from "../../../utils";
import HeaderButtons from '../Buttons/header-buttons';

import LazyLoad from '../Image/LazyLoad';

const SmallBanner = props => {
	const { className = '', h2 = false, banner = null } = props;

	if (!banner) {
		return;
	}

	return (
		<SiteContext.Consumer>
			{({ deviceType }) => (
				<div className={`smallBanner ${className}`}>
					<div className="imageHolder">
						<div className="overlay">
							{banner?.image?.overseasModelShown ? (
								<h6 className="disc">*Overseas model shown</h6>
							) : null}
						</div>
						<LazyLoad
							image={_oldSelectImageForDevice(deviceType, banner)}
							alt={banner.title}
							title={banner.title}
						/>
					</div>
					<div className="productBannerCopyHolder">
						<div className="productBannerCopy">
							<div className="copy">
								<div className="line" />
								{h2 ? (
									<h2>{banner.title}</h2>
								) : (
									<h1>{banner.title}</h1>
								)}
							</div>
						</div>
						{banner && banner.buttons && banner.buttons !== null && banner.buttons.length > 0 &&
							<HeaderButtons buttons={banner.buttons} />}
					</div>
				</div>
			)}
		</SiteContext.Consumer>
	);
};

export default SmallBanner;